import { Action, AppThunk } from '../definitions/types';

// tslint:disable-next-line no-any
export type AmbiguousAction = AppThunk<any> | Action<any>;

// tslint:disable-next-line no-any
const isAction = (action: AmbiguousAction): boolean => {
  return typeof action !== 'function';
};

export default isAction;
